import { __extends } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
var ImageReloader = /** @class */ (function (_super) {
    __extends(ImageReloader, _super);
    function ImageReloader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleVisibilityChange = function () {
            if (!document.hidden) {
                _this.props.reloadImages();
            }
        };
        return _this;
    }
    ImageReloader.prototype.componentDidMount = function () {
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
    };
    ImageReloader.prototype.componentWillUnmount = function () {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange, false);
    };
    ImageReloader.prototype.render = function () {
        return null;
    };
    ImageReloader.propTypes = {
        reloadImages: PropTypes.func.isRequired,
    };
    return ImageReloader;
}(React.Component));
export default ImageReloader;
